"use client";
import { useEffect } from "react";

export default function BackgroundTask() {
  useEffect(() => {
    const runTask = async () => {
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}product-management/fetch-and-save-printify-data-in-product-collection`
        );
        if (!res.ok) throw new Error(`HTTP error ${res.status}`);
        const data = await res.json();
        console.log("Background API response:", data);
      } catch (err) {
        console.error("Background API error:", err);
      }
    };
    

    runTask();

    const intervalId = setInterval(runTask, 60 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, []);

  return null;
}
